import { render, staticRenderFns } from "./BaseMessage.vue?vue&type=template&id=ee5f4532&scoped=true&"
import script from "./BaseMessage.vue?vue&type=script&lang=js&"
export * from "./BaseMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseMessage.vue?vue&type=style&index=0&id=ee5f4532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5f4532",
  null
  
)

export default component.exports